import { useEffect, useState } from "react";

export const Countdown = ({ target, testId }) => {
  const [left, setLeft] = useState(target - Date.now());
  useEffect(() => {
    const t = setInterval(() => setLeft(target - Date.now()), 1000);
    return () => clearInterval(t);
  }, [target]);
  if (left <= 0) return null;
  const s = Math.floor(left / 1000);
  const parts = [
    [Math.floor(s / 86400), "d"],
    [Math.floor((s % 86400) / 3600), "st"],
    [Math.floor((s % 3600) / 60), "min"],
    [s % 60, "sek"],
  ].filter(([v], i) => v > 0 || i > 0);
  return (
    <div className="flex gap-2" data-testid={testId}>
      {parts.map(([v, l]) => (
        <div key={l} className="bg-[#111111] text-white px-2.5 py-1.5 text-center min-w-[52px]">
          <div className="text-lg font-extrabold leading-none tabular-nums">{String(v).padStart(2, "0")}</div>
          <div className="text-[10px] uppercase tracking-widest text-white/60">{l}</div>
        </div>
      ))}
    </div>
  );
};

export const midnight = () => {
  const d = new Date();
  d.setHours(24, 0, 0, 0);
  return d.getTime();
};
